(function () {
    function clamp(n, max) {
        n = Math.max(1, Math.round(n || 1));
        return Math.min(n, max || 1);
    }

    function mount() {
        var $ = window.jQuery;
        if (!$ || !$.fn || typeof $.fn.slick !== 'function') return;

        var sliders = document.querySelectorAll('.ow-mobile-screen-block-slider[data-mobile]');
        sliders.forEach(function (el) {
            if (!el || el.classList.contains('slick-initialized')) return;

            var total = el.querySelectorAll('.slider-item-wrapper').length;
            var d = clamp(parseFloat(el.getAttribute('data-desktop')), total);
            var t = clamp(parseFloat(el.getAttribute('data-tablet')), total);
            var m = clamp(parseFloat(el.getAttribute('data-mobile')), total);


            $(el).slick({
                autoplay: false,
                arrows: false,
                dots: false,
                infinite: false,
                swipeToSlide: true,
                speed: 500,
                autoplaySpeed: 5000,
                slidesToScroll: 1,
                slidesToShow: d,
                touchThreshold: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: t,
                            slidesToScroll: 1,
                            infinite: false,

                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: m,
                            slidesToScroll: 1,
                            infinite: false,

                        }
                    }
                ]
            });

            var container = el.parentElement || document;
            var prevButton = container && container.querySelector('.ow-mobile-screen__arrow-prev');
            var nextButton = container && container.querySelector('.ow-mobile-screen__arrow-next');
            if (prevButton) prevButton.addEventListener('click', function () { $(el).slick('slickPrev'); });
            if (nextButton) nextButton.addEventListener('click', function () { $(el).slick('slickNext'); });
        });
    }

    function waitAndMount() {
        if (typeof jQuery === 'undefined' || !jQuery.fn || typeof jQuery.fn.slick !== 'function') {
            return setTimeout(waitAndMount, 50);
        }
        mount();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitAndMount);
    } else {
        waitAndMount();
    }
})();


